var _circle, _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 9,
    r: 9,
    fill: "#35313F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.479 23.053a1 1 0 01.097 1.41l-6.207 7.12-.094.092c-.858.825-2.03 1.351-3.328 1.324-1.296-.027-2.441-.599-3.263-1.447l-4.12-4.248a1 1 0 00-.718-.304h-7.692a1 1 0 00-.718.304l-4.12 4.248c-.822.848-1.968 1.42-3.263 1.447-1.298.027-2.47-.499-3.328-1.324l-.037-.036-6.234-6.432a1 1 0 01.022-1.414l2.872-2.784a1 1 0 011.414.022l4.48 4.622a1 1 0 001.436 0l4.22-4.35a1 1 0 01.717-.303h12.77a1 1 0 01.718.304l4.124 4.252a1 1 0 001.471-.04l4.355-4.995a1 1 0 011.41-.097l3.016 2.629z",
    fill: "#35313F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35313F",
    d: "M15 24h18v21H15z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 48,
    height: 6,
    rx: 2,
    fill: "#35313F"
  })));
}

export default SvgClasses;